"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
class EventBus {
    constructor() {
        this.handlers = {};
    }
    addHandler(name, handler, token) {
        let handlers = this.handlers[name];
        if (!handlers)
            handlers = this.handlers[name] = [];
        handlers.push({ token, handler });
    }
    removeHandler(nameOrToken, handler) {
        if (handler) {
            const name = nameOrToken;
            const handlers = this.handlers[name];
            if (!handlers)
                return;
            const index = handlers.findIndex(h => h.handler === handler);
            if (index < 0)
                return;
            handlers.splice(index, 1);
        }
        else {
            const token = nameOrToken;
            if (token === undefined)
                return;
            for (const prop in this.handlers) {
                const handlers = this.handlers[prop];
                if (!handlers)
                    continue;
                for (let i = 0; i < handlers.length; i++) {
                    if (handlers[i].token === token) {
                        handlers.splice(i, 1);
                        i--;
                    }
                }
            }
        }
    }
    raise(name, arg0 = null, arg1 = null, arg2 = null, arg3 = null) {
        let handled = false;
        const handlers = this.handlers[name];
        if (!handlers)
            return false;
        for (let i = 0; i < handlers.length; i++) {
            handled = handlers[i].handler(arg0, arg1, arg2, arg3);
            if (handled === true)
                return true;
        }
        return false;
    }
}
exports.EventBus = EventBus;
//# sourceMappingURL=module.js.map
//# sourceMappingURL=data:application/json;base64,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